/* ==========================================================================
  Bb cross Game Constants
========================================================================== */
export const MIN_MINE_COUNT = 1
export const MAX_MINE_COUNT = 24
export const MIN_TILE_COUNT = 1
export const MAX_TILE_COUNT = 25
export const DEFAULT_MINE_COUNT = 3
export const DEFAULT_MINE_GAME_AUTOBET_ROUNDS = '∞'

export const DEFAULT_DIFFICULTY_VALUE = 1

export const LANE_MINE_TILE_COUNT = { 1: 24, 2: 22, 3: 20, 4: 15 }

export const LANE_MINE_FIXED_ODDS = {
  1: [1, 1.04, 1.09, 1.14, 1.20, 1.26, 1.33, 1.41, 1.50, 1.60, 1.71, 1.85, 2, 2.18, 2.40, 2.67, 3, 3.43, 4, 4.80, 6, 8, 12, 24],
  2: [1.09, 1.25, 1.43, 1.66, 1.94, 2.28, 2.71, 3.25, 3.94, 4.85, 6.07, 7.72, 10.04, 13.38, 18.40, 26.29, 39.43, 63.09, 110.40, 220.80, 552, 2208],
  3: [1.20, 1.52, 1.94, 2.51, 3.29, 4.39, 5.95, 8.24, 11.68, 16.98, 25.48, 39.63, 64.40, 110.40, 202.40, 404.80, 910.80, 2428.80, 8500.80, 51004.80],
  4: [1.60, 2.74, 4.85, 8.90, 16.98, 33.97, 71.71, 161.35, 391.86, 1044.96, 3134.87, 10972.06, 47545.60, 285273.60, 3138009.60]
}

export const TABS = {
  ALL_BETS: 'ALL_BETS',
  TOP_BETS: 'TOP_BETS'
}
